import { render, staticRenderFns } from "./ProductContent.vue?vue&type=template&id=a02b1788&scoped=true"
import script from "./ProductContent.vue?vue&type=script&lang=js"
export * from "./ProductContent.vue?vue&type=script&lang=js"
import style0 from "./ProductContent.vue?vue&type=style&index=0&id=a02b1788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02b1788",
  null
  
)

export default component.exports